export default __webpack_public_path__ + "static/media/ballYellow.7be49856.svg";